import * as React from 'react';
import {
    PageSection,
    PageSectionVariants,
    Text,
    TextContent,
    Title,
} from '@patternfly/react-core';
import { Page } from "@keycloak/keycloak-account-ui";
import { useTranslation } from "react-i18next";

export function WelcomePage(): React.ReactNode {
    const { t } = useTranslation();
    return <Page title={t("welcomeTitle")} description={t("welcomeIntroMessage")}>
        <PageSection variant={PageSectionVariants.light} padding={{ default: 'noPadding' }}>
            <TextContent>
                <Title size="xl" headingLevel="h2">
                    {t("welcomeHeading")}
                </Title>
                <Text>
                    {t('welcome')}
                </Text>
            </TextContent>
        </PageSection>
    </Page>
}
